// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .main_section {
  margin: 4rem 0;

  & h6 {
    color: #242020;
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & p {
    padding-top: 0.6rem;
    color: #242020;
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 500;
  }
}

.imageContainer {
  width: 100%;
}

.image,
.image_1,
.image_2,
.image_3 {

  width: 30%;
  height: 550px;
  transition: transform 0.5s ease-in-out;
}

.imageContainer:hover .image {
  transform: scale(1.5);
  width: 100%;
  height: 550px;
}

.title {
  display: none;
  position: absolute;
  left: 0;
  bottom: 0;

  & h6 {
    color: var(--text-color);
    font-family: Inter;
    font-weight: 700;
    font-size: 1.8rem;
  }

  & p {
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    color: var(--text-color);
  }
}



.ImageMainSection {
  display: flex;
  overflow: hidden;
}

.imageContainer {
  width: 100%;
}

.image {
  width: 100%;
  height: auto;
  object-fit: cover;
  transition: width 0.3s linear;
  transform-origin: left center;
}

.imageContainer:hover .image {
  width: 100%;
  height: auto;
  transform: scaleX(1.7);
}

@media screen and (max-width: 568px) {
  .main_section {
    margin: 0;
  }
} */

.sec_main_section__VZUZ9 {
  margin: 4rem 0;

  & h6 {
    margin: 0;
    color: #242020;
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & p {
    padding-top: 0.6rem;
    color: #242020;
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 500;
  }
}

.sec_ImageMainSection__z2aim {
  display: flex;
  overflow: hidden;
}

.sec_imageContainer__Sv9UG {
  position: relative;
  width: 30%;
  overflow: hidden;
  /* transition: width 0.3s ease-in-out; */
}

.sec_image__pPzwS {
  width: 100%;
  height: 600px;
  object-fit: cover;
  transition: width 0.3s linear;
  transform-origin: left;
}

.sec_title__2FVRu {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: Start;
  padding: 10px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  & h6 {
    color: var(--text-color);
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & p {
    color: var(--text-color);
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 500;
  }
}

.sec_imageContainer__Sv9UG:hover {
  width: 60%;
}

.sec_imageContainer__Sv9UG:hover .sec_image__pPzwS {
  width: 100%;
  height: 600px;
  transform: scaleX(1.7);
}

.sec_imageContainer__Sv9UG:hover .sec_title__2FVRu {
  opacity: 1;
}

@media screen and (max-width: 568px) {
  .sec_main_section__VZUZ9 {
    margin: 0;
  }

  .sec_ImageMainSection__z2aim {
    flex-direction: column;
  }

  .sec_imageContainer__Sv9UG {
    width: 100%;
  }

  .sec_imageContainer__Sv9UG:hover {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/ImageSection/sec.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyFG;;AAEH;EACE,cAAc;;EAEd;IACE,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,oCAAoC;;EAEpC;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* .main_section {\n  margin: 4rem 0;\n\n  & h6 {\n    color: #242020;\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & p {\n    padding-top: 0.6rem;\n    color: #242020;\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 500;\n  }\n}\n\n.imageContainer {\n  width: 100%;\n}\n\n.image,\n.image_1,\n.image_2,\n.image_3 {\n\n  width: 30%;\n  height: 550px;\n  transition: transform 0.5s ease-in-out;\n}\n\n.imageContainer:hover .image {\n  transform: scale(1.5);\n  width: 100%;\n  height: 550px;\n}\n\n.title {\n  display: none;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n\n  & h6 {\n    color: var(--text-color);\n    font-family: Inter;\n    font-weight: 700;\n    font-size: 1.8rem;\n  }\n\n  & p {\n    font-family: Inter;\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--text-color);\n  }\n}\n\n\n\n.ImageMainSection {\n  display: flex;\n  overflow: hidden;\n}\n\n.imageContainer {\n  width: 100%;\n}\n\n.image {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n  transition: width 0.3s linear;\n  transform-origin: left center;\n}\n\n.imageContainer:hover .image {\n  width: 100%;\n  height: auto;\n  transform: scaleX(1.7);\n}\n\n@media screen and (max-width: 568px) {\n  .main_section {\n    margin: 0;\n  }\n} */\n\n.main_section {\n  margin: 4rem 0;\n\n  & h6 {\n    margin: 0;\n    color: #242020;\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & p {\n    padding-top: 0.6rem;\n    color: #242020;\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 500;\n  }\n}\n\n.ImageMainSection {\n  display: flex;\n  overflow: hidden;\n}\n\n.imageContainer {\n  position: relative;\n  width: 30%;\n  overflow: hidden;\n  /* transition: width 0.3s ease-in-out; */\n}\n\n.image {\n  width: 100%;\n  height: 600px;\n  object-fit: cover;\n  transition: width 0.3s linear;\n  transform-origin: left;\n}\n\n.title {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  text-align: Start;\n  padding: 10px;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n\n  & h6 {\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & p {\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 500;\n  }\n}\n\n.imageContainer:hover {\n  width: 60%;\n}\n\n.imageContainer:hover .image {\n  width: 100%;\n  height: 600px;\n  transform: scaleX(1.7);\n}\n\n.imageContainer:hover .title {\n  opacity: 1;\n}\n\n@media screen and (max-width: 568px) {\n  .main_section {\n    margin: 0;\n  }\n\n  .ImageMainSection {\n    flex-direction: column;\n  }\n\n  .imageContainer {\n    width: 100%;\n  }\n\n  .imageContainer:hover {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `sec_main_section__VZUZ9`,
	"ImageMainSection": `sec_ImageMainSection__z2aim`,
	"imageContainer": `sec_imageContainer__Sv9UG`,
	"image": `sec_image__pPzwS`,
	"title": `sec_title__2FVRu`
};
export default ___CSS_LOADER_EXPORT___;
